import React from "react";
// TYPE_BADGE constant để thay thế import từ utils/constant
const TYPE_BADGE = {
  positions: {
    tl: "absolute top-2 left-2",
    tr: "absolute top-2 right-2",
    bl: "absolute bottom-2 left-2",
    br: "absolute bottom-2 right-2",
  },
};

interface IPoint {
  containerStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  className?: string;
  value?: number | string;
  position?: "tl" | "tr" | "bl" | "br";
  size?: number;
  width?: number;
  height?: number;
}

// Hàm xác định màu nền dựa trên điểm số
const getPointBackgroundColor = (point: number | string): string => {
  const numericPoint = typeof point === "string" ? parseFloat(point) : point;

  if (isNaN(numericPoint)) return "bg-gray-400";

  if (numericPoint >= 8 && numericPoint <= 10) {
    return "bg-excellent"; // excellent
  }
  if (numericPoint >= 6 && numericPoint < 8) {
    return "bg-good"; // good
  }
  if (numericPoint >= 4 && numericPoint < 6) {
    return "bg-bad"; // bad
  }
  if (numericPoint >= 0 && numericPoint < 4) {
    return "bg-terrible"; // terrible
  }

  return "bg-gray-400"; // default
};

const Point = ({
  value,
  position = "tl",
  containerStyle = {},
  textStyle = {},
  className = "",
  size,
  width = 36,
  height = 36,
}: IPoint) => {
  // Không hiển thị nếu không có value
  if (!value && value !== 0) return null;

  // Xác định kích thước
  let w = width;
  let h = height;
  if (size !== undefined) {
    w = size;
    h = size;
  }

  // Lấy position class từ TYPE_BADGE
  const positionClass =
    TYPE_BADGE.positions[position] || TYPE_BADGE.positions.tl;

  // Xác định màu nền dựa trên điểm số
  const bgColorClass = getPointBackgroundColor(value);

  // Hàm format giá trị: làm tròn xuống 1 chữ số thập phân
  const formatValue = (val: number | string): string => {
    const numericVal = typeof val === "string" ? parseFloat(val) : val;
    if (isNaN(numericVal)) return String(val);

    const rounded = Math.floor(numericVal * 10) / 10;

    return rounded % 1 === 0 ? String(Math.floor(rounded)) : rounded.toFixed(1);
  };

  return (
    <div
      className={`${positionClass} ${bgColorClass} z-10 flex items-center justify-center rounded-lg ${className}`}
      style={{
        width: `${w}px`,
        height: `${h}px`,
        ...containerStyle,
      }}
    >
      <span
        className="text-white text-xs font-semibold"
        style={{
          ...textStyle,
        }}
      >
        {formatValue(value)}
      </span>
    </div>
  );
};

export default Point;
